import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  ca: { translation: {
    nav: { home: "Inici", directory: "Comerços", incidents: "Incidències", giftcard: "Targeta Regal", check: "Consultar saldo", login: "Accés associats", admin: "Admin", logout: "Sortir", panel_admin: "Panell Admin", zone_shop: "Zona comerç", zone_assoc: "Zona associat" },
    home: {
      overline: "Associació de Comerciants",
      title_1: "El comerç de Salou,",
      title_2: "connectat i viu.",
      subtitle: "Comunica incidències, regala experiències locals i descobreix les campanyes i comerços associats.",
      cta_incident: "Comunicar incidència",
      cta_giftcard: "Comprar Targeta Regal",
      cta_web: "Web Shopping Salou",
      hero_badge: "Costa Daurada",
      hero_badge_2: "200+ comerços al teu abast",
      quick_access: "Accessos ràpids",
      access_cta: "Accedeix",
      news: "Notícies destacades",
      activities: "Properes activitats",
      no_activities: "No hi ha activitats programades.",
      campaigns: "Últimes campanyes",
      no_campaigns: "No hi ha campanyes actives.",
      overline_news: "Actualitat",
      campaign_tag: "Campanya",
      qa_incident_desc: "Notifica un problema a la via pública en menys d'un minut",
      qa_gift_desc: "Regala moments locals amb targeta virtual",
      qa_check_desc: "Consulta el saldo del teu val",
      qa_login_desc: "Accedeix a la zona privada dels associats",
    },
    incidents: {
      title: "Comunica una incidència",
      subtitle: "Ens ajudes a mantenir Salou en el millor estat possible",
      overline: "Via pública",
      category: "Categoria",
      description: "Descripció",
      name: "Nom (opcional)",
      email: "Correu electrònic (opcional)",
      photo: "Fotografia",
      add_photo: "Afegir foto",
      location: "Localització",
      use_gps: "Utilitza la meva ubicació",
      locating: "Localitzant...",
      address_ph: "Adreça o referència",
      submit: "Enviar incidència",
      success: "Incidència enviada. Gràcies!",
      success_sub: "Farem el seguiment i ho resoldrem al més aviat possible.",
      new_incident: "Enviar una altra incidència",
      err_gps: "GPS no disponible",
      err_location: "No s'ha pogut obtenir la ubicació",
      err_photo_size: "Foto massa gran (màx 4MB)",
      err_desc_required: "Descripció obligatòria",
      err_submit: "Error enviant. Torna-ho a provar.",
      loc_success: "Ubicació registrada",
      categories: { cleaning: "Neteja", urban_furniture: "Mobiliari urbà", lighting: "Il·luminació", signage: "Senyalització", security: "Seguretat", other: "Altres" },
    },
    gift: {
      title: "Targeta Regal Shopping Salou",
      subtitle: "Regala una experiència local que es pot bescanviar a més de 200 comerços de Salou",
      overline: "Regals locals",
      valid_12: "Vàlida durant 12 mesos",
      choose_amount: "Escull l'import",
      buyer: "Les teves dades",
      recipient: "Dades del destinatari",
      buyer_name_ph: "El teu nom",
      buyer_email_ph: "El teu email",
      recipient_name_ph: "Nom del destinatari",
      recipient_email_ph: "Email del destinatari",
      message: "Missatge personalitzat",
      message_ph: "Un missatge que farà somriure...",
      buy: "Comprar amb Stripe",
      redirecting: "Redirigint a Stripe...",
      secure_note: "Pagament segur amb Stripe. Rebràs el codi al correu del destinatari.",
      err_required: "Omple tots els camps obligatoris",
      err_checkout: "Error creant la compra",
      check_title: "Consulta el saldo de la teva targeta",
      check_overline: "Targeta Regal",
      check_placeholder: "Introdueix el codi (p.ex. XXXX-XXXX-XXXX)",
      check_btn: "Consultar",
      check_invalid: "Codi no vàlid",
      balance_available: "Saldo disponible",
      initial_of: "de {{amount}} € inicials",
      movements: "Moviments",
      no_movements: "Encara no s'ha bescanviat.",
      redeem: "Bescanvi",
      topup: "Càrrega",
    },
    directory: {
      overline: "Comerços associats",
      title: "Directori de Shopping Salou",
      subtitle: "Descobreix els {{count}} comerços associats i les {{promos}} promocions actives a Salou.",
      search_ph: "Cerca un comerç...",
      all_categories: "Totes les categories",
      tab_grid: "Graella",
      tab_promos: "Promocions actives ({{count}})",
      view_profile: "Veure fitxa",
      no_shops: "Cap comerç coincideix amb la cerca.",
      no_promos: "Ara mateix no hi ha promocions actives.",
      map_title: "Al mapa de Salou",
      map_showing: "Mostrant <1>{{shown}}</1> de {{total}} comerços al mapa",
      promo_active: "Actiu",
      promo_by: "Per {{name}}",
      until: "Fins {{date}}",
      promo_count: "{{count}} promoció",
      promo_count_plural: "{{count}} promocions",
      cats: { restauracio: "Restauració", moda: "Moda", salut: "Salut", cultura: "Cultura", serveis: "Serveis", alimentacio: "Alimentació", esports: "Esports", altres: "Altres", general: "General" },
    },
    login: { title: "Accés associats", subtitle: "Introdueix les teves credencials", email: "Correu", password: "Contrasenya", submit: "Entrar", entering: "Entrant...", welcome: "Benvingut/da, {{name}}", err_auth: "Error d'autenticació" },
    admin: {
      dashboard: "Dashboard", associates: "Associats", incidents: "Incidències", giftcards: "Targetes Regal",
      campaigns: "Campanyes", mailings: "Mailing", documents: "Documents", invoices: "Facturació", agenda: "Agenda", notifications: "Notificacions", users: "Usuaris i rols", settings: "Configuració",
      citizens: "Ciutadans", interests: "Interessos",
      collaborators: "Col·laboradors", promotions_review: "Promocions públiques",
    },
    assoc: {
      dashboard: "Inici", services: "Serveis generals", agenda: "Agenda", card: "Targeta digital", marketplace: "Avantatges", invoices: "Les meves factures", notifications: "Notificacions", profile: "Perfil",
    },
    footer: {
      copyright: "© 2026 · Associació de Comerciants de Salou · Tarragona",
      tag: "Fet amb cura · PWA · WCAG 2.2 AA",
    },
    dash: { greeting: "Bon dia, {{name}} 👋", active_campaigns: "Campanyes actives", view_all: "Veure totes", no_campaigns: "Sense campanyes actives.", upcoming: "Properes activitats", agenda_link: "Agenda", no_events: "Sense activitats.", alerts: "Avisos", no_alerts: "Sense avisos.", recent_docs: "Documents recents", view_all_docs: "Veure tots", no_docs: "Sense documents." },
    common: { search: "Cerca", save: "Desar", cancel: "Cancel·lar", delete: "Eliminar", edit: "Editar", create: "Crear", export: "Exportar", loading: "Carregant…", back: "Enrere", lang: "Idioma" },
    a11y: { skip_to_content: "Salta al contingut", light_mode: "Mode clar", dark_mode: "Mode fosc", change_lang: "Canvia d'idioma", theme_toggle: "Canvia el tema", open_menu: "Obre el menú", close_menu: "Tanca el menú", user_menu: "Menú d'usuari" },
    pwa: { install_cta: "Instal·la l'app", install_aria: "Instal·la Shopping Salou al teu dispositiu", dismiss_aria: "Descarta", ios_title: "Instal·la a l'iPhone", ios_intro: "Afegeix Shopping Salou a la pantalla d'inici per accedir-hi com una app.", ios_step1_before: "Toca el botó Compartir", ios_step1_after: "a la barra inferior de Safari.", ios_step2_before: "Selecciona", ios_step2_label: "Afegir a Inici", ios_step3: "Confirma amb «Afegir». L'app apareixerà a la teva pantalla.", ios_got_it: "Entesos" },
  }},
  es: { translation: {
    nav: { home: "Inicio", directory: "Comercios", incidents: "Incidencias", giftcard: "Tarjeta Regalo", check: "Consultar saldo", login: "Acceso asociados", admin: "Admin", logout: "Salir", panel_admin: "Panel Admin", zone_shop: "Zona comercio", zone_assoc: "Zona asociado" },
    home: {
      overline: "Asociación de Comerciantes",
      title_1: "El comercio de Salou,",
      title_2: "conectado y vivo.",
      subtitle: "Comunica incidencias, regala experiencias locales y descubre las campañas y comercios asociados.",
      cta_incident: "Comunicar incidencia",
      cta_giftcard: "Comprar Tarjeta Regalo",
      cta_web: "Web Shopping Salou",
      hero_badge: "Costa Daurada",
      hero_badge_2: "200+ comercios a tu alcance",
      quick_access: "Accesos rápidos",
      access_cta: "Accede",
      news: "Noticias destacadas",
      activities: "Próximas actividades",
      no_activities: "No hay actividades programadas.",
      campaigns: "Últimas campañas",
      no_campaigns: "No hay campañas activas.",
      overline_news: "Actualidad",
      campaign_tag: "Campaña",
      qa_incident_desc: "Notifica un problema en la vía pública en menos de un minuto",
      qa_gift_desc: "Regala momentos locales con tarjeta virtual",
      qa_check_desc: "Consulta el saldo de tu vale",
      qa_login_desc: "Accede a la zona privada de los asociados",
    },
    incidents: {
      title: "Comunica una incidencia",
      subtitle: "Nos ayudas a mantener Salou en el mejor estado",
      overline: "Vía pública",
      category: "Categoría", description: "Descripción", name: "Nombre (opcional)", email: "Correo (opcional)",
      photo: "Fotografía", add_photo: "Añadir foto", location: "Ubicación", use_gps: "Usar mi ubicación",
      locating: "Localizando...", address_ph: "Dirección o referencia",
      submit: "Enviar incidencia",
      success: "¡Incidencia enviada. Gracias!",
      success_sub: "Haremos el seguimiento y lo resolveremos lo antes posible.",
      new_incident: "Enviar otra incidencia",
      err_gps: "GPS no disponible",
      err_location: "No se pudo obtener la ubicación",
      err_photo_size: "Foto demasiado grande (máx 4MB)",
      err_desc_required: "Descripción obligatoria",
      err_submit: "Error al enviar. Vuelve a intentarlo.",
      loc_success: "Ubicación registrada",
      categories: { cleaning: "Limpieza", urban_furniture: "Mobiliario urbano", lighting: "Iluminación", signage: "Señalización", security: "Seguridad", other: "Otros" },
    },
    gift: {
      title: "Tarjeta Regalo Shopping Salou", subtitle: "Regala una experiencia local canjeable en más de 200 comercios de Salou",
      overline: "Regalos locales", valid_12: "Válida durante 12 meses",
      choose_amount: "Elige el importe", buyer: "Tus datos", recipient: "Datos del destinatario",
      buyer_name_ph: "Tu nombre", buyer_email_ph: "Tu email",
      recipient_name_ph: "Nombre del destinatario", recipient_email_ph: "Email del destinatario",
      message: "Mensaje personalizado", message_ph: "Un mensaje que hará sonreír...",
      buy: "Comprar con Stripe", redirecting: "Redirigiendo a Stripe...",
      secure_note: "Pago seguro con Stripe. Recibirás el código en el correo del destinatario.",
      err_required: "Rellena todos los campos obligatorios",
      err_checkout: "Error al crear la compra",
      check_title: "Consulta el saldo de tu tarjeta",
      check_overline: "Tarjeta Regalo",
      check_placeholder: "Introduce el código", check_btn: "Consultar",
      check_invalid: "Código no válido",
      balance_available: "Saldo disponible",
      initial_of: "de {{amount}} € iniciales",
      movements: "Movimientos",
      no_movements: "Aún no se ha canjeado.",
      redeem: "Canje", topup: "Recarga",
    },
    directory: {
      overline: "Comercios asociados",
      title: "Directorio de Shopping Salou",
      subtitle: "Descubre los {{count}} comercios asociados y las {{promos}} promociones activas en Salou.",
      search_ph: "Busca un comercio...",
      all_categories: "Todas las categorías",
      tab_grid: "Cuadrícula",
      tab_promos: "Promociones activas ({{count}})",
      view_profile: "Ver ficha",
      no_shops: "Ningún comercio coincide con la búsqueda.",
      no_promos: "Ahora mismo no hay promociones activas.",
      map_title: "En el mapa de Salou",
      map_showing: "Mostrando <1>{{shown}}</1> de {{total}} comercios en el mapa",
      promo_active: "Activa",
      promo_by: "Por {{name}}",
      until: "Hasta {{date}}",
      promo_count: "{{count}} promoción",
      promo_count_plural: "{{count}} promociones",
      cats: { restauracio: "Restauración", moda: "Moda", salut: "Salud", cultura: "Cultura", serveis: "Servicios", alimentacio: "Alimentación", esports: "Deportes", altres: "Otros", general: "General" },
    },
    login: { title: "Acceso asociados", subtitle: "Introduce tus credenciales", email: "Correo", password: "Contraseña", submit: "Entrar", entering: "Entrando...", welcome: "Bienvenido/a, {{name}}", err_auth: "Error de autenticación" },
    admin: { dashboard: "Dashboard", associates: "Asociados", users: "Usuarios y roles", incidents: "Incidencias", giftcards: "Tarjetas Regalo", campaigns: "Campañas", mailings: "Mailing", documents: "Documentos", invoices: "Facturación", agenda: "Agenda", notifications: "Notificaciones", settings: "Configuración", citizens: "Ciudadanos", interests: "Intereses", collaborators: "Colaboradores", promotions_review: "Promociones públicas" },
    assoc: { dashboard: "Inicio", services: "Servicios", agenda: "Agenda", card: "Tarjeta digital", marketplace: "Ventajas", invoices: "Mis facturas", notifications: "Notificaciones", profile: "Perfil" },
    footer: { copyright: "© 2026 · Asociación de Comerciantes de Salou · Tarragona", tag: "Hecho con cuidado · PWA · WCAG 2.2 AA" },
    dash: { greeting: "Buenos días, {{name}} 👋", active_campaigns: "Campañas activas", view_all: "Ver todas", no_campaigns: "Sin campañas activas.", upcoming: "Próximas actividades", agenda_link: "Agenda", no_events: "Sin actividades.", alerts: "Avisos", no_alerts: "Sin avisos.", recent_docs: "Documentos recientes", view_all_docs: "Ver todos", no_docs: "Sin documentos." },
    common: { search: "Buscar", save: "Guardar", cancel: "Cancelar", delete: "Eliminar", edit: "Editar", create: "Crear", export: "Exportar", loading: "Cargando…", back: "Atrás", lang: "Idioma" },
    a11y: { skip_to_content: "Saltar al contenido", light_mode: "Modo claro", dark_mode: "Modo oscuro", change_lang: "Cambiar idioma", theme_toggle: "Cambiar tema", open_menu: "Abrir menú", close_menu: "Cerrar menú", user_menu: "Menú de usuario" },
    pwa: { install_cta: "Instalar app", install_aria: "Instalar Shopping Salou en tu dispositivo", dismiss_aria: "Descartar", ios_title: "Instalar en iPhone", ios_intro: "Añade Shopping Salou a la pantalla de inicio y úsalo como una app.", ios_step1_before: "Toca el botón Compartir", ios_step1_after: "en la barra inferior de Safari.", ios_step2_before: "Selecciona", ios_step2_label: "Añadir a Inicio", ios_step3: "Confirma con «Añadir». La app aparecerá en tu pantalla.", ios_got_it: "Entendido" },
  }},
  en: { translation: {
    nav: { home: "Home", directory: "Shops", incidents: "Report Issue", giftcard: "Gift Card", check: "Check Balance", login: "Members Login", admin: "Admin", logout: "Logout", panel_admin: "Admin Panel", zone_shop: "Shop area", zone_assoc: "Member area" },
    home: {
      overline: "Merchants Association", title_1: "Salou's local commerce,", title_2: "connected & alive.",
      subtitle: "Report public issues, gift local experiences and discover campaigns from associated shops.",
      cta_incident: "Report an issue", cta_giftcard: "Buy Gift Card", cta_web: "Shopping Salou Website",
      hero_badge: "Costa Daurada", hero_badge_2: "200+ shops at your fingertips",
      quick_access: "Quick access", access_cta: "Access", news: "Featured news", activities: "Upcoming activities", no_activities: "No scheduled activities.", campaigns: "Latest campaigns",
      no_campaigns: "No active campaigns.", overline_news: "Latest",
      campaign_tag: "Campaign",
      qa_incident_desc: "Report a public issue in under a minute",
      qa_gift_desc: "Give local moments with a virtual card",
      qa_check_desc: "Check the balance of your voucher",
      qa_login_desc: "Access the members-only area",
    },
    incidents: {
      title: "Report an issue", subtitle: "Help us keep Salou in top shape",
      overline: "Public area",
      category: "Category", description: "Description", name: "Name (optional)", email: "Email (optional)",
      photo: "Photo", add_photo: "Add photo", location: "Location", use_gps: "Use my location",
      locating: "Locating...", address_ph: "Address or reference",
      submit: "Send report",
      success: "Report sent. Thanks!",
      success_sub: "We'll follow up and solve it as soon as possible.",
      new_incident: "Send another report",
      err_gps: "GPS unavailable",
      err_location: "Could not get location",
      err_photo_size: "Photo too large (max 4MB)",
      err_desc_required: "Description is required",
      err_submit: "Sending failed. Try again.",
      loc_success: "Location captured",
      categories: { cleaning: "Cleaning", urban_furniture: "Street furniture", lighting: "Lighting", signage: "Signage", security: "Security", other: "Other" },
    },
    gift: {
      title: "Shopping Salou Gift Card", subtitle: "A local experience redeemable at 200+ shops in Salou",
      overline: "Local gifting", valid_12: "Valid for 12 months",
      choose_amount: "Choose amount", buyer: "Your details", recipient: "Recipient details",
      buyer_name_ph: "Your name", buyer_email_ph: "Your email",
      recipient_name_ph: "Recipient name", recipient_email_ph: "Recipient email",
      message: "Personal message", message_ph: "A message that will make them smile...",
      buy: "Buy with Stripe", redirecting: "Redirecting to Stripe...",
      secure_note: "Secure payment via Stripe. The code will be emailed to the recipient.",
      err_required: "Fill in all required fields",
      err_checkout: "Failed to create checkout",
      check_title: "Check your card balance",
      check_overline: "Gift Card",
      check_placeholder: "Enter code", check_btn: "Check",
      check_invalid: "Invalid code",
      balance_available: "Available balance",
      initial_of: "of {{amount}} € initial",
      movements: "Movements",
      no_movements: "Not redeemed yet.",
      redeem: "Redeem", topup: "Top-up",
    },
    directory: {
      overline: "Associated shops",
      title: "Shopping Salou Directory",
      subtitle: "Discover the {{count}} associated shops and the {{promos}} active promotions in Salou.",
      search_ph: "Search a shop...",
      all_categories: "All categories",
      tab_grid: "Grid",
      tab_promos: "Active promotions ({{count}})",
      view_profile: "View profile",
      no_shops: "No shops match the search.",
      no_promos: "There are no active promotions right now.",
      map_title: "On the Salou map",
      map_showing: "Showing <1>{{shown}}</1> of {{total}} shops on the map",
      promo_active: "Active",
      promo_by: "By {{name}}",
      until: "Until {{date}}",
      promo_count: "{{count}} promotion",
      promo_count_plural: "{{count}} promotions",
      cats: { restauracio: "Food", moda: "Fashion", salut: "Health", cultura: "Culture", serveis: "Services", alimentacio: "Grocery", esports: "Sports", altres: "Other", general: "General" },
    },
    login: { title: "Members login", subtitle: "Enter your credentials", email: "Email", password: "Password", submit: "Sign in", entering: "Signing in...", welcome: "Welcome, {{name}}", err_auth: "Authentication error" },
    admin: { dashboard: "Dashboard", associates: "Members", users: "Users & roles", incidents: "Incidents", giftcards: "Gift Cards", campaigns: "Campaigns", mailings: "Newsletters", documents: "Documents", invoices: "Invoicing", agenda: "Agenda", notifications: "Notifications", settings: "Settings", citizens: "Citizens", interests: "Interests", collaborators: "Collaborators", promotions_review: "Public promotions" },
    assoc: { dashboard: "Home", services: "Resources", agenda: "Agenda", card: "Digital card", marketplace: "Perks", invoices: "My invoices", notifications: "Notifications", profile: "Profile" },
    footer: { copyright: "© 2026 · Salou Merchants Association · Tarragona", tag: "Crafted with care · PWA · WCAG 2.2 AA" },
    dash: { greeting: "Hi, {{name}} 👋", active_campaigns: "Active campaigns", view_all: "See all", no_campaigns: "No active campaigns.", upcoming: "Upcoming activities", agenda_link: "Agenda", no_events: "No activities.", alerts: "Alerts", no_alerts: "No alerts.", recent_docs: "Recent documents", view_all_docs: "See all", no_docs: "No documents." },
    common: { search: "Search", save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit", create: "Create", export: "Export", loading: "Loading…", back: "Back", lang: "Language" },
    a11y: { skip_to_content: "Skip to content", light_mode: "Light mode", dark_mode: "Dark mode", change_lang: "Change language", theme_toggle: "Toggle theme", open_menu: "Open menu", close_menu: "Close menu", user_menu: "User menu" },
    pwa: { install_cta: "Install app", install_aria: "Install Shopping Salou on your device", dismiss_aria: "Dismiss", ios_title: "Install on iPhone", ios_intro: "Add Shopping Salou to your Home Screen and use it as an app.", ios_step1_before: "Tap the Share button", ios_step1_after: "in Safari's bottom bar.", ios_step2_before: "Choose", ios_step2_label: "Add to Home Screen", ios_step3: "Confirm with «Add». The app will appear on your screen.", ios_got_it: "Got it" },
  }},
  fr: { translation: {
    nav: { home: "Accueil", directory: "Commerces", incidents: "Signaler", giftcard: "Carte Cadeau", check: "Vérifier solde", login: "Espace membre", admin: "Admin", logout: "Sortir", panel_admin: "Panneau Admin", zone_shop: "Espace commerce", zone_assoc: "Espace membre" },
    home: {
      overline: "Association de Commerçants", title_1: "Le commerce de Salou,", title_2: "connecté et vivant.",
      subtitle: "Signalez, offrez des expériences locales et découvrez les campagnes des commerces adhérents.",
      cta_incident: "Signaler un incident", cta_giftcard: "Acheter Carte Cadeau", cta_web: "Site Shopping Salou",
      hero_badge: "Costa Daurada", hero_badge_2: "200+ commerces à portée de main",
      quick_access: "Accès rapide", access_cta: "Accéder", news: "Actualités", activities: "Prochaines activités", no_activities: "Aucune activité programmée.", campaigns: "Dernières campagnes",
      no_campaigns: "Aucune campagne active.", overline_news: "Actualité",
      campaign_tag: "Campagne",
      qa_incident_desc: "Signalez un problème en moins d'une minute",
      qa_gift_desc: "Offrez des moments locaux",
      qa_check_desc: "Vérifiez le solde de votre bon",
      qa_login_desc: "Accédez à l'espace membre",
    },
    incidents: {
      title: "Signaler un incident", subtitle: "Aidez-nous à garder Salou impeccable",
      overline: "Voie publique",
      category: "Catégorie", description: "Description", name: "Nom (optionnel)", email: "Email (optionnel)",
      photo: "Photo", add_photo: "Ajouter photo", location: "Localisation", use_gps: "Ma position",
      locating: "Localisation...", address_ph: "Adresse ou référence",
      submit: "Envoyer",
      success: "Signalement envoyé. Merci !",
      success_sub: "Nous ferons le suivi et le résoudrons dès que possible.",
      new_incident: "Envoyer un autre signalement",
      err_gps: "GPS indisponible",
      err_location: "Impossible d'obtenir la position",
      err_photo_size: "Photo trop grande (max 4Mo)",
      err_desc_required: "Description obligatoire",
      err_submit: "Erreur d'envoi. Réessayez.",
      loc_success: "Position enregistrée",
      categories: { cleaning: "Nettoyage", urban_furniture: "Mobilier urbain", lighting: "Éclairage", signage: "Signalisation", security: "Sécurité", other: "Autres" },
    },
    gift: {
      title: "Carte Cadeau Shopping Salou", subtitle: "Une expérience locale valable dans +200 commerces de Salou",
      overline: "Cadeaux locaux", valid_12: "Valable 12 mois",
      choose_amount: "Montant", buyer: "Vos coordonnées", recipient: "Destinataire",
      buyer_name_ph: "Votre nom", buyer_email_ph: "Votre email",
      recipient_name_ph: "Nom du destinataire", recipient_email_ph: "Email du destinataire",
      message: "Message personnel", message_ph: "Un mot qui fera sourire...",
      buy: "Acheter avec Stripe", redirecting: "Redirection Stripe...",
      secure_note: "Paiement sécurisé Stripe. Le code sera envoyé par email au destinataire.",
      err_required: "Remplissez tous les champs obligatoires",
      err_checkout: "Erreur de création du paiement",
      check_title: "Vérifiez le solde",
      check_overline: "Carte Cadeau",
      check_placeholder: "Saisir le code", check_btn: "Vérifier",
      check_invalid: "Code invalide",
      balance_available: "Solde disponible",
      initial_of: "sur {{amount}} € initiaux",
      movements: "Mouvements",
      no_movements: "Non utilisée.",
      redeem: "Utilisation", topup: "Recharge",
    },
    directory: {
      overline: "Commerces adhérents",
      title: "Annuaire Shopping Salou",
      subtitle: "Découvrez les {{count}} commerces adhérents et les {{promos}} promotions actives à Salou.",
      search_ph: "Chercher un commerce...",
      all_categories: "Toutes les catégories",
      tab_grid: "Grille",
      tab_promos: "Promotions actives ({{count}})",
      view_profile: "Voir la fiche",
      no_shops: "Aucun commerce ne correspond.",
      no_promos: "Aucune promotion active actuellement.",
      map_title: "Sur la carte de Salou",
      map_showing: "{{shown}} sur {{total}} commerces affichés",
      promo_active: "Active",
      promo_by: "Par {{name}}",
      until: "Jusqu'au {{date}}",
      promo_count: "{{count}} promotion",
      promo_count_plural: "{{count}} promotions",
      cats: { restauracio: "Restauration", moda: "Mode", salut: "Santé", cultura: "Culture", serveis: "Services", alimentacio: "Alimentation", esports: "Sports", altres: "Autres", general: "Général" },
    },
    login: { title: "Espace membre", subtitle: "Vos identifiants", email: "Email", password: "Mot de passe", submit: "Se connecter", entering: "Connexion...", welcome: "Bienvenue, {{name}}", err_auth: "Erreur d'authentification" },
    admin: { dashboard: "Tableau de bord", associates: "Adhérents", users: "Utilisateurs et rôles", incidents: "Incidents", giftcards: "Cartes Cadeaux", campaigns: "Campagnes", mailings: "Newsletters", documents: "Documents", invoices: "Facturation", agenda: "Agenda", notifications: "Notifications", settings: "Paramètres", citizens: "Citoyens", interests: "Intérêts", collaborators: "Partenaires", promotions_review: "Promotions publiques" },
    assoc: { dashboard: "Accueil", services: "Ressources", agenda: "Agenda", card: "Carte numérique", marketplace: "Avantages", invoices: "Mes factures", notifications: "Notifications", profile: "Profil" },
    footer: { copyright: "© 2026 · Association des Commerçants de Salou · Tarragone", tag: "Fait avec soin · PWA · WCAG 2.2 AA" },
    dash: { greeting: "Bonjour, {{name}} 👋", active_campaigns: "Campagnes actives", view_all: "Voir tout", no_campaigns: "Aucune campagne active.", upcoming: "Prochaines activités", agenda_link: "Agenda", no_events: "Aucune activité.", alerts: "Notifications", no_alerts: "Aucune notification.", recent_docs: "Documents récents", view_all_docs: "Voir tout", no_docs: "Aucun document." },
    common: { search: "Rechercher", save: "Enregistrer", cancel: "Annuler", delete: "Supprimer", edit: "Modifier", create: "Créer", export: "Exporter", loading: "Chargement…", back: "Retour", lang: "Langue" },
    a11y: { skip_to_content: "Aller au contenu", light_mode: "Mode clair", dark_mode: "Mode sombre", change_lang: "Changer de langue", theme_toggle: "Changer de thème", open_menu: "Ouvrir le menu", close_menu: "Fermer le menu", user_menu: "Menu utilisateur" },
    pwa: { install_cta: "Installer l'app", install_aria: "Installer Shopping Salou sur votre appareil", dismiss_aria: "Fermer", ios_title: "Installer sur iPhone", ios_intro: "Ajoutez Shopping Salou à l'écran d'accueil pour l'utiliser comme une app.", ios_step1_before: "Appuyez sur le bouton Partager", ios_step1_after: "dans la barre de Safari.", ios_step2_before: "Choisissez", ios_step2_label: "Sur l'écran d'accueil", ios_step3: "Confirmez avec «Ajouter». L'app apparaîtra sur votre écran.", ios_got_it: "C'est compris" },
  }},
};

const stored = typeof window !== "undefined" ? localStorage.getItem("ss_lang") : null;
const initialLang = stored || "ca";

i18n.use(initReactI18next).init({
  resources,
  lng: initialLang,
  fallbackLng: "ca",
  interpolation: { escapeValue: false },
});

// Sync <html lang="..."> attribute
if (typeof document !== "undefined") {
  document.documentElement.setAttribute("lang", initialLang);
  i18n.on("languageChanged", (lng) => {
    document.documentElement.setAttribute("lang", lng);
  });
}

export default i18n;
